const authActions = {
    SIGN_IN: 'SIGN_IN',
    SIGN_OUT: 'SIGN_OUT',
    UPGRADE_ANON: 'UPGRADE_ANON',
    UPDATE_DISPLAY_NAME: 'UPDATE_DISPLAY_NAME'
}

export default Object.freeze(authActions);